import apiWrapper from 'Helpers/apiWrapper'
import { encodeParams } from 'mailup-react-helpers'
const endpoints = ((baseURL) => {
  return {
    getEntitiesThatUseMessage: (idMessage) =>
      `${baseURL}/api/message/${idMessage}/entities`,

    getMessageLinks: (idMessage, params) =>
      `${baseURL}/api/message/${idMessage}/links?${encodeParams(params)}`,
    getMessageLazyDetails: (idMessage) =>
      `${baseURL}/api/message/${idMessage}/lazy`,
    getDynamicContentList: (idlist, params) =>
      `${baseURL}/api/dynamiccontents/list/${idlist}/contents?${encodeParams(
        params
      )}`,
    deleteDynamicContent: (idContent) =>
      `${baseURL}/api/dynamiccontents/content/${idContent}`,
    getDynamicContentLastSendDate: (idContent) =>
      `${baseURL}/api/dynamiccontents/lastsenddate`,
    searchMessages: (idList, params) =>
      `${baseURL}/api/list/${idList}/messages/search?${encodeParams(params)}`,
    getMessageDetailsLazy: (idMessage) =>
      `${baseURL}/api/message/${encodeURIComponent(idMessage)}/lazy`,
    listRssFeedByIdList: (idList, params) =>
      `${baseURL}/api/rssfeed/list/${idList}?${encodeParams(params)}`,
    listDynamicContentByIdMessage: (idMessage) =>
      `${baseURL}/api/dynamiccontents/message/${idMessage}`,
    // thumbnail

    createMessageThumbnail: (idMessage) =>
      `${baseURL}/api/thumbnail/${idMessage}`
  }
})(process.env.BEEMAILMESSAGE_URL)

export const beEmailMessageGetMessageLinks = (idMessage) => {
  const params = {
    excludesendtoafriend: true
  }
  const url = endpoints.getMessageLinks(idMessage, params)
  return apiWrapper({
    method: 'get',
    url
  }).then((res) => res.data)
}
export const getDynamicContentList = (idlist, params) => {
  const url = endpoints.getDynamicContentList(idlist, params)
  return apiWrapper({
    method: 'get',
    url
  }).then((res) => res.data)
}
export const beContentGetDynamicContentLastSendDate = (params) => {
  const url = endpoints.getDynamicContentLastSendDate(params)

  return apiWrapper({
    method: 'post',
    url,
    headers: {
      'Content-Type': 'application/json'
    },
    data: JSON.stringify(params)
  }).then((res) => res.data)
}

export const beContentDeleteDynamicContent = (idContent) => {
  const url = endpoints.deleteDynamicContent(idContent)
  return apiWrapper({
    method: 'delete',
    url
  }).then((res) => res.data)
}

export const beEmailMessageGetMessageLazyDetails = (idMessage) => {
  const url = endpoints.getMessageLazyDetails(idMessage)

  return apiWrapper({
    method: 'get',
    url
  }).then((res) => res.data)
}

export const beEmailMessageSearchMessages = (idList, params, bodyParams) => {
  const url = endpoints.searchMessages(idList, params)
  return apiWrapper({
    method: 'post',
    url,
    data: JSON.stringify(bodyParams)
  }).then((res) => res.data)
}

/**
 * @description Get the message details lazy
 * @param {number} idMessage
 * @returns {object}
 */
export const beEmailMessageApiGetMessageDetailsLazy = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getMessageDetailsLazy(idMessage)
  }).then((res) => res.data)
}

export const beEmalMessagelistRssFeedByIdList = (idList, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.listRssFeedByIdList(idList, params)
  }).then((res) => res.data)
}

export const beEmailMessageApiListDynamicContentByIdMessage = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.listDynamicContentByIdMessage(idMessage)
  }).then((res) => res.data)
}

export const beEmailMessageApiCreateMessageThumbnail = (idMsg) => {
  const url = endpoints.createMessageThumbnail(idMsg)
  return apiWrapper({
    method: 'post',
    url
  }).then((res) => res.data)
}

export const beEmailMessageApiGetEntitiesThatUseMessage = (idMessage) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getEntitiesThatUseMessage(idMessage)
  }).then((res) => res.data)
}
